import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-114" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-115" data-mp="9tl66pubh5qm">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-ivory rounded-3xl border border-line p-8 shadow-card sm:p-12" data-id="element-116" data-mp="et66p4p4xm5g">
          <span className="inline-flex rounded-full border border-gold/30 bg-goldSoft p-4 text-alert" data-id="element-117" data-mp="skcbngb6obzq">
            <ShieldCheckIcon className="h-10 w-10" data-id="element-118" data-mp="xkgs56c3d6py" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-ink" data-id="element-119" data-mp="xlrwb79g8ghl">Garantía de 7 días, sin preguntas</h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-120" data-mp="17hlhtg55bkbi">
            Abrís los tomos. Los usás en el aula. Si en 7 días no es lo que esperabas, solicitás tu devolución.
          </p>
          <p className="mt-6 rounded-xl border border-gold/30 bg-goldSoft px-5 py-4 text-lg font-extrabold text-alert" data-id="element-121" data-mp="20su412tqqnr0">
            Devolución del 100% sin formularios, sin drama.
          </p>
          <p className="mt-5 text-xs font-bold uppercase tracking-[.14em] text-muted" data-id="element-122" data-mp="1rs5ou4sm2hcj">Tasa de devoluciones: menos del 1%</p>
        </motion.div>
      </div>
    </section>;
}